import React from 'react'
import MatchScreenApp from './MatchScreenApp'
import PreviewRibbon from './components/PreviewRibbon/PreviewRibbon'
import { MatchScreenProvider, MatchScreenDatasetAttributes } from './context/MatchScreenContext'
import { RedesignConfigProvider } from './redesign/context/RedesignConfigContext'

interface MatchScreenWrapperProps {
  attributes: MatchScreenDatasetAttributes
}

/**
 * Wrapper component that sets up the match screen providers before rendering
 * MatchScreenApp. The redesign config is server-evaluated (read from
 * `window.matchScreenRedesign`), so no client-side flag decision needs to
 * resolve before rendering.
 */
function MatchScreenWrapper ({ attributes }: MatchScreenWrapperProps) {
  return (
    <MatchScreenProvider attributes={attributes}>
      <RedesignConfigProvider isPreview={attributes.isPreview}>
        {/* The preview ribbon sits above both match screen variants */}
        {attributes.isPreview && <PreviewRibbon />}
        <MatchScreenApp />
      </RedesignConfigProvider>
    </MatchScreenProvider>
  )
}

export default MatchScreenWrapper
